import $ from "jquery";
import { decode as base64_decode, encode as base64_encode } from "base-64";

export default function ParserImage() {
  $(".contentpage a").each(function () {
    let srcdata = $(this).attr("href");
    if (srcdata !== undefined) {
      if (srcdata.substring(0, 1) === "/") {
        srcdata = srcdata.replaceAll("%20", " ");
        let encoded = base64_encode(srcdata);
        $(this).attr(
          "href",
          global.config.backend + "/api/getimage/" + encoded
        );
      }
    }
  });

  $("img").each(function () {
    let srcdata = $(this).attr("src");
    if (srcdata !== undefined) {
      if (srcdata.substring(0, 1) === "/") {
        srcdata = srcdata.replaceAll("%20", " ");
        let encoded = base64_encode(srcdata);
        $(this).attr("src", global.config.backend + "/api/getimage/" + encoded);
      }
    }
  });
}
